import axios from 'axios';
import { addBearerTokenInReq } from './interceptors/addBearerTokenInReq';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { AuthService } from '.';
import { getLocalAuthStorage } from 'utils/localStorage';
import { localStorageKeys } from 'constants/localStorage';
import { settIsRefreshing } from 'utils/refresh';
import { handleAuthError } from './interceptors/handleAuthError';
import { wait } from 'utils/helpers/promises';
const isRefreshDone = async () => {
  const storage = getLocalAuthStorage();
  return await wait(300).then(() => {
    if (!storage.isRefreshing) {
      return storage.token;
    } else {
      return isRefreshDone();
    }
  });
};
// Function that will be called to refresh authorization
export const refreshAuthLogic = async failedRequest => {
  const storage = getLocalAuthStorage();
  const token = storage?.token;
  const refreshToken = storage?.refreshToken;

  if (failedRequest.config.url === '/v1/auth') {
    return new Promise((_, reject) => reject(failedRequest.response));
  }
  if (failedRequest.response.status === 401) {
    if (!storage.isRefreshing) {
      settIsRefreshing(true);
      return await AuthService.refreshToken({ token, refreshToken })
        .then(({ data }) => {
          const newToken = data.authToken.token;
          storage.token = newToken;
          storage.refreshToken = data.authToken.refreshToken;
          storage.expiresIn = data.authToken.expiresIn;
          storage.isRefreshing = false;
          localStorage.setItem(localStorageKeys.authContext, JSON.stringify(storage));
          failedRequest.response.config.headers['Authorization'] = 'Bearer ' + newToken;
          return Promise.resolve();
        })
        .catch(() => {
          storage.isRefreshing = false;
          localStorage.setItem(localStorageKeys.authContext, JSON.stringify(storage));
          window.location.replace('/logout');
        });
    } else {
      await isRefreshDone().then(token => {
        failedRequest.response.config.headers['Authorization'] = 'Bearer ' + token;
        return Promise.resolve();
      });
    }
  }
  if (failedRequest.response.status !== 401 && token) {
    return new Promise((_, reject) => reject(failedRequest));
  }
};

const AxiosMain = axios.create({
  baseURL: process.env.REACT_APP_AUTH_API,
});

const AxiosMock = axios.create({
  baseURL: process.env.REACT_APP_MOCK_API,
});
const AxiosCharts = axios.create({
  baseURL: process.env.REACT_APP_LAS_CHART_API,
});
const AxiosGlobalFilters = axios.create({
  baseURL: process.env.REACT_APP_LIGHTHOUSE_FILTERS_API,
});
const AxiosMenuLas = axios.create({
  baseURL: process.env.REACT_APP_LAS,
});
AxiosGlobalFilters.interceptors.request.use(addBearerTokenInReq);
AxiosMain.interceptors.request.use(addBearerTokenInReq);
AxiosMain.interceptors.response.use(res => res, handleAuthError);

createAuthRefreshInterceptor(AxiosGlobalFilters, refreshAuthLogic);
export { AxiosMain, AxiosCharts, AxiosGlobalFilters, AxiosMock, AxiosMenuLas };
